import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import { PageName } from '@/components/PageHeader/styles'
import { Container } from '@/containers/styles'

export const PageContainer = styled(Container)<{
  $isSearchTab?: boolean
}>`
  .line {
    padding: 0 0 28px;
  }
  ${({ $isSearchTab }) =>
    $isSearchTab &&
    css`
      overflow: initial;
    `}
`
export const HeaderElem = styled.header`
  position: relative;
  height: 165px;
  margin-right: 112px;
  padding-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${PageName} {
    color: ${({ theme }) => theme.colors.search.text};
    font-size: 40px;
    font-weight: 700;
  }
`
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 915px;
`
export const ContentUnavailableWrapper = styled.div`
  height: 380px;
  margin-right: 112px;
`
export const SearchInputWrapper = styled.div`
  margin-bottom: 60px;
  margin-right: 112px;
`
export const Input = styled.div`
  width: 100%;
  height: 64px;
  background: ${({ theme }) => theme.colors.search.background};
  color: ${({ theme }) => theme.colors.search.text};
  font-size: 26px;
  line-height: 64px;
  padding: 0 24px;
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.search.border};
  text-overflow: ellipsis;
  border-radius: 32px;
  overflow: hidden;

  strong {
    font-weight: 500;
  }

  span {
    opacity: 0.5;
  }
`

export const SearchControls = styled(FocusNode)`
  min-height: 380px;
  position: relative;

  &::after {
    content: '';
    display: block;
    clear: both;
  }
`

export const SearchControlsItem = styled.div`
  float: left;

  &:last-child {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
`

export const SuggestionsWrapper = styled(FocusNode)`
  display: table;
  min-height: 50px;
  width: 300px;
`
export const SuggestionsItemWrapper = styled.div`
  display: table-row;
`
export const SuggestionsTitle = styled.div`
  color: ${({ theme }) => theme.colors.search.text};
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0 0 16px;
`
export const SuggestionsItem = styled.div`
  display: table-cell;
`
export const SuggestionsChip = styled(FocusNode)`
  max-width: 450px;
  display: inline-block;
  height: 60px;
  padding: 0 22px;
  font-size: 20px;
  line-height: 60px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.search.text};
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.search.border};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: ${({ theme }) => theme.colors.search.background};
  border-radius: 30px;

  &.isFocusedLeaf {
    box-shadow: inset 0 0 0 2px
      ${(props) => props.theme.colors.search.focusedElem.border};
    background: ${({ theme }) => theme.colors.search.focusedElem.background};
  }
`
